var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoIconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.816,
    height: 13.816,
    viewBox: "0 0 13.816 13.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-play-circle",
    "data-name": "Icon ionic-ios-play-circle",
    d: "M-632.776,353.116a6.909,6.909,0,0,0-6.909,6.908,6.909,6.909,0,0,0,6.908,6.909,6.908,6.908,0,0,0,6.909-6.908h0a6.907,6.907,0,0,0-6.906-6.908Zm2.4,7.357-3.732,2.308s-.631.309-.664-.431v-4.357c0-.118-.1-.77.582-.64l3.813,2.334C-630.033,359.929-630.281,360.416-630.377,360.473Z",
    transform: "translate(639.684 -353.116)",
    fill: "#3e3e3e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconBlack);
export default __webpack_public_path__ + "static/media/videoIconBlack.50a52c404c1fa9245da0bcb291b1af70.svg";
export { ForwardRef as ReactComponent };